export const name = 'fullDataViewDirective';
export default function fullDataViewDirective() {
//noinspection BadExpressionStatementJS

    'ngInject';

    var directive = {
        restrict: 'E',
        template: require('./fullDataView.html'),
        scope: {

        },

        controller: fullDataViewController,
        controllerAs: 'vm',
        bindToController: true
    };

    return directive;
}

function fullDataViewController($log,$scope,uiGridColumnMenuService, $interval, $stateParams, $translate, $state, breadcrumbsService) {
    //noinspection BadExpressionStatementJS
    'ngInject';

    var vm = this;
    vm.data = $stateParams.data;
    vm.headers = $stateParams.headers;
    vm.dataFileName = $stateParams.dataFileName;
    vm.isDataFileLimitExceeded = $stateParams.isDataFileLimitExceeded;
    vm.repetitionColumn = $stateParams.repetitionColumn;
    let iconsRequire = require.context('@printos/imposer-ui/src/components/templates/images/icons', false, /\.svg/);
    vm.infoIcon = iconsRequire('./Info.svg');

    vm.activate = setupData;
    vm.dataToDisplay = [];
    vm.gridOptions = {
        enableColumnResizing: true,
        data: vm.dataToDisplay,
        onRegisterApi: function(gridApi) {
            vm.gridApi = gridApi;
        }
    };

    setupData();


    function setupData(){

        if(vm.dataFileName === undefined || vm.dataFileName === null || vm.dataFileName === ""){
            vm.dataFileName = $translate.instant('imposer.composer-main.Imposition_Default_Data');
        }

        breadcrumbsService.isBreadcrumbsFeatureEnabled().then(isNewBreadcrumbsActivated => {
          if(!isNewBreadcrumbsActivated) {
            vm.breadcrumbs=[
              {
                state: 'templates',
                titleKey: 'imposer.composer-main.Template_Imposition_Templates'
              },
              {
                state: '^',
                titleKey: 'imposer.composer-main.Template_Imposition_Template'
              },
              {
                state: $state.current.name,
                titleKey: 'imposer.composer-main.Template_Database'
              }
            ];
          }
        });

        if((vm.data !== undefined) && (vm.data !== null) && (vm.headers !== undefined) && (vm.headers !== null)){
            vm.headers = vm.headers.map(curr => curr.replace(".", "_"));

            vm.gridOptions.columnDefs = [];
            for(let iColumn = 0; iColumn < vm.headers.length; iColumn++){
              vm.gridOptions.columnDefs.push({});
              vm.gridOptions.columnDefs[iColumn].field = vm.headers[iColumn];
              vm.gridOptions.columnDefs[iColumn].headerTooltip = vm.headers[iColumn];
              vm.gridOptions.columnDefs[iColumn].enableColumnMenu = false;
              vm.gridOptions.columnDefs[iColumn].cellTooltip = true;
            }

            vm.dataToDisplay = [];
            for(let iRecord = 0; iRecord < vm.data.length; iRecord++){
                let record = {};
                for(let iColumn = 0; iColumn < vm.headers.length; iColumn++){
                    record[vm.headers[iColumn]] =  vm.data[iRecord][iColumn];
                }
                vm.dataToDisplay.push(record);
            }

            vm.gridOptions.data = vm.dataToDisplay;
            $log.debug(angular.toJson(vm.dataToDisplay));
        }
    }
}

